import { render } from "./AuctionsCreating.vue?vue&type=template&id=45caa949&ts=true"
import script from "./AuctionsCreating.vue?vue&type=script&lang=ts"
export * from "./AuctionsCreating.vue?vue&type=script&lang=ts"

import "./AuctionsCreating.vue?vue&type=style&index=0&id=45caa949&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__